import { Stack, Tab, Tabs } from '@mui/material'
import { useCallback, useMemo } from 'react'
import PropertyList from './PropertyList'
import Page from '../components/Page'
import UsersList from './ListUsers'
import { Switch, Route, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined'

const Organisation = () => {
  const match = useRouteMatch()
  const history = useHistory()
  const location = useLocation()
  const tab = useMemo<'users' | 'properties'>(() => {
    const pathTab = location.pathname.split('/')?.[2]
    return pathTab === 'users' ? 'users' : 'properties'
  }, [location.pathname])

  const onChange = useCallback(tab => {
    history.push(`${match.path}/${tab}`)
  }, [history, match.path])

  return (
    <Page title={'Organisation'} size="xl">
      <Tabs value={tab} onChange={(_, newValue) => onChange(newValue)} aria-label="organisation navigation">
        <Tab
          value="properties"
          label={
            <Stack direction="row" alignItems="center">
              <DomainOutlinedIcon sx={{ mr: 1 }} /> Properties
            </Stack>
          }
        />
        <Tab
          value="users"
          label={
            <Stack direction="row" alignItems="center">
              <PeopleOutlineOutlinedIcon sx={{ mr: 1 }} /> Users
            </Stack>
          }
        />
      </Tabs>
      <Switch>
        <Route exact path={match.path}>
          <Redirect to={`${match.path}/properties`} />
        </Route>
        <Route path={`${match.path}/properties`}>
          <PropertyList />
        </Route>
        <Route path={`${match.path}/users`}>
          <UsersList />
        </Route>
      </Switch>
    </Page>
  )
}

export default Organisation
